import { View } from 'react-native';

type AppColumnProps = {
  children: React.ReactNode;
}

export function AppColumn(props: AppColumnProps) {
  return (<View style={{ flex: 1 }}>{props.children}</View>);
}
